<template>
  <add-page
    :selectedNavItem="selectedNavItem"
    :toggleForm="toggleForm"
    @form-submited="submit()"
  >
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-select
        :items="tests"
        item-text="title"
        filled
        return-object
        v-model="requestData.SelectedTest"
        :rules="[(v) => !!v || '*Required']"
        label="Test"
      ></v-select>
      <v-text-field
        dense
        label="MinimumValue"
        :rules="NoEmptyRule"
        filled
        required
        type="number"
        v-model="requestData.MinimumValue"
      ></v-text-field>

      <v-text-field
        dense
        type="number"
        label="MaximumValue"
        :rules="NoEmptyRule"
        filled
        required
        v-model="requestData.MaximumValue"
      ></v-text-field>
    </v-form>
  </add-page>
</template>
<script>
import AddPage from "../AddPage.vue";
import apiClient from "../../API/apiClient";
import { mapActions, mapGetters } from "vuex";
export default {
  components: { AddPage },
  name: "add-specimen-type",
  props: ["selectedNavItem", "toggleForm"],
  created() {
    this.getTests();
  },
  data() {
    return {
      valid: false,
      unitOfMeasurements: [],
      requestData: {
        MinimumValue: "",
        MaximumValue: "",
        Description: "",
        SelectedTest: null,
        TestId: null,
      },
      institutions: [],
      name: "",
      NoEmptyRule: [(v) => !!v || "*required"],
    };
  },
  methods: {
    ...mapActions(["getTests"]),
    submit() {
      if (this.$refs.form.validate()) {
        this.requestData.InstitutionId = this.currentInstitution.id;
        this.requestData.TestId = this.requestData.SelectedTest.id;
        apiClient
          .call(
            "POST",
            "institutions/" +
              this.currentInstitution.id +
              "/tests/" +
              this.requestData.TestId +
              "/testResultRanges",
            this.requestData
          )
          .then((response) => {
            console.log(response);
            this.toggleForm();
            this.$store.dispatch("getAllTestResultRanges");
          })
          .catch((err) => console.log(err));
      }
    },
  },
  computed: {
    ...mapGetters(["currentInstitution", "tests"]),
  },
};
</script>